/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metric } from './Metric';
import {
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    MetricToJSONTyped,
} from './Metric';

/**
 * 
 * @export
 * @interface BusinessReportOrderTagsNetSalesResponse
 */
export interface BusinessReportOrderTagsNetSalesResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof BusinessReportOrderTagsNetSalesResponse
     */
    data: Array<Metric>;
}

/**
 * Check if a given object implements the BusinessReportOrderTagsNetSalesResponse interface.
 */
export function instanceOfBusinessReportOrderTagsNetSalesResponse(value: object): value is BusinessReportOrderTagsNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportOrderTagsNetSalesResponseFromJSON(json: any): BusinessReportOrderTagsNetSalesResponse {
    return BusinessReportOrderTagsNetSalesResponseFromJSONTyped(json, false);
}

export function BusinessReportOrderTagsNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportOrderTagsNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricFromJSON)),
    };
}

export function BusinessReportOrderTagsNetSalesResponseToJSON(json: any): BusinessReportOrderTagsNetSalesResponse {
    return BusinessReportOrderTagsNetSalesResponseToJSONTyped(json, false);
}

export function BusinessReportOrderTagsNetSalesResponseToJSONTyped(value?: BusinessReportOrderTagsNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricToJSON)),
    };
}

